module.exports = __webpack_public_path__ + "static/img/7.552c0926.png";